import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star_icon_jax_87d5daa7f9309ea1dfe308cea53765b5",
  "use": "star_icon_jax_87d5daa7f9309ea1dfe308cea53765b5-usage",
  "viewBox": "0 0 59 57",
  "content": "<symbol viewBox=\"0 0 59 57\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star_icon_jax_87d5daa7f9309ea1dfe308cea53765b5\">\n<path d=\"M29.4998 5.10156L37.7369 20.2053L54.6468 23.372L42.8277 35.8732L45.0415 52.9341L29.4998 45.5565L13.958 52.9341L16.1718 35.8732L4.35272 23.372L21.2626 20.2053L29.4998 5.10156Z\" fill=\"#2CD4AE\" stroke=\"white\" stroke-width=\"4.06787\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol